import React from 'react'
import { Header2, Header3, Text } from '../../styles/Components'
import { gsColors as c } from '../../styles/Variables'
import Button from '../Button'
import Image from 'next/image'
import styled from '@emotion/styled'
import { mq } from '../../helpers'
import PrepImage from '../../../public/how-it-works/how_it_works_prep.webp'

const PrepWrapper = styled.section`
  width: 100%;
  max-width: 1600px;
  display: flex;
  flex-direction: row;

  ${mq('max', '768px')} {
    flex-direction: column-reverse;
  }

  .content {
    width: 50%;
    background-color: ${c.cobalt};
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 88px 104px 88px 88px;

    ${mq('max', '1280px')} {
      padding: 88px;
    }

    ${mq('max', '1024px')} {
      padding: 44px;
    }

    ${mq('max', '768px')} {
      width: 100%;
      padding: 48px 16px;
    }
  }

  .divider {
    width: 100%;
    border-top: 1px solid ${c.white};
    margin: 20px 0;
  }

  .image-placeholder {
    width: 50%;
    position: relative;
    min-height: 907px;

    img {
      object-position: top;
    }

    ${mq('max', '768px')} {
      width: 100%;
      min-height: 498px;
    }
  }
`

const Prepping = () => (
  <PrepWrapper>
    <div className="content">
      <Header2 color={c.white} margin="0 0 12px 0">
        Prepping is easy
      </Header2>
      <Header3 color={c.white} fontSize={24} margin="0 0 56px 0">
        All we need is a flat surface with an outlet nearby to set up our
        products and tools.
      </Header3>
      <Text variant="medium" weight={700} color={c.white} margin="0 0 6px 0">
        Hair
      </Text>
      <Text variant="small" lineHeight="145%" color={c.white}>
        For blowouts and silk press, make sure you have damp hair. For dry
        styling and updos, second-day hair is best.
      </Text>
      <div className="divider" />
      <Text variant="medium" weight={700} color={c.white} margin="0 0 6px 0">
        Makeup
      </Text>
      <Text variant="small" lineHeight="145%" color={c.white}>
        For best results, we suggest cleansing and moisturizing your skin
        before we arrive.
      </Text>
      <div className="divider" />
      <Text variant="medium" weight={700} color={c.white} margin="0 0 6px 0">
        Nails
      </Text>
      <Text variant="small" lineHeight="145%" color={c.white}>
        Ensure nails are free of hard gels or acrylics, as we&apos;re unable
        to remove them. (We can remove shellac or soakable gels for a fee.)
      </Text>
      <Button
        outline
        color={c.salmon}
        path="/book"
        large
        margin="56px 0 0 0"
      >
        Book Now
      </Button>
    </div>
    <div className="image-placeholder">
      <Image
        src={PrepImage}
        style={{ objectFit: 'cover' }}
        fill
        sizes="(max-width: 768px) 100vw, 50vw"
        alt="Woman preparing for her in-home Glamsquad beauty appointment"
      />
    </div>
  </PrepWrapper>
)

export default Prepping
